import React, { CSSProperties } from 'react';
import { Drawer, DrawerProps } from 'antd';

/**
 * Custom Drawer wrapper with modern styling
 */
export interface MyDrawerProps extends DrawerProps {
  variant?: 'default' | 'gradient' | 'dark';
  blur?: boolean;
}

const MyDrawer: React.FC<MyDrawerProps> = ({
  variant = 'default',
  blur = false,
  style,
  className,
  children,
  ...rest
}) => {
  // Variant styles
  const variantStyles: Record<string, CSSProperties> = {
    default: {
      background: '#fff',
    },
    gradient: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
    },
    dark: {
      background: '#1f1f1f',
      color: '#fff',
    },
  };

  const customStyle: CSSProperties = {
    ...variantStyles[variant],
    ...style,
  };

  const maskStyle: CSSProperties = blur
    ? {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
      }
    : {};

  return (
    <Drawer
      style={customStyle}
      maskStyle={maskStyle}
      className={className}
      {...rest}
    >
      {children}
    </Drawer>
  );
};

export default MyDrawer;
